import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Button } from '@/components/Button/Button';
import { contactsPageObject } from '@/utils';
import { iconByTypeMap, linkPrefixes } from './ContactList.data';
import type { ContactsListProps } from './ContactList.types';
import styles from './ContactsList.module.scss';
export const ContactsList: FC<ContactsListProps> = ({
  contacts
}) => {
  const {
    t
  } = useTranslation('contacts');
  if (!contacts.length) {
    return null;
  }
  return <>
      <h2 {...contactsPageObject.title.nodeProps} className={styles.title}>
        {t('contacts_block.title', 'technical support')}
      </h2>
      <div className={styles.container}>
        {contacts.map(({
        type,
        title,
        value
      }, index) => {
        const Icon = iconByTypeMap[type];
        return <div className={styles.block} key={index}>
              <Button {...contactsPageObject.contacts(type).nodeProps} as="link" variant="text" href={`${linkPrefixes[type] ?? ''}${value}`} className={styles.linkContainer}>
                <h2 className={styles.subtitle}>{t(title)}</h2>
                <div className={styles.linkBlock}>
                  <Icon className={styles.buttonIcon} />
                  <span className={styles.text}>{t(value)}</span>
                </div>
              </Button>
            </div>;
      })}
      </div>
    </>;
};